<template>
  <div>
    <b-card class="mb-2">
      <!-- workspace tokens -->
      <b-row class="border-bottom mb-2">
        <b-col cols="10">
          <h4>Workspace Networks</h4>
          <p>These networks are used to send data to your PRYM Workspace</p>
        </b-col>
        <b-col>
          <b-button
            variant="outline-primary"
            size="sm"
            class="float-right mb-1"
            @click="showAddNetworkModal = true"
          >
            Add Network
          </b-button>
        </b-col>
      </b-row>

      <b-row class="mb-2">
        <b-col>
          <b-form-input
            v-model="search"
            type="search"
            placeholder="Search for a network"
            @input="filterNetworks"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col
          v-for="network in filteredNetworks"
          :key="network.id"
          cols="12"
          sm="6"
          md="4"
          lg="3"
          class="mb-4"
        >
          <b-card
            class="h-100 border"
            no-body
          >
            <b-card-header
              class="d-flex justify-content-between align-items-center"
            >
              <div>
                <h5 class="mb-0">
                  {{ network.networkType.name }}
                </h5>
                <small class="text-muted">{{
                  network && network.networkOrgName
                }}</small>
              </div>
              <b-img
                v-if="network.networkType.logoLink"
                alt="Image"
                :src="network.networkType.logoLink"
                height="64"
                width="64"
              />
            </b-card-header>
            <b-card-body>
              <b-card-text>
                <div>
                  {{ network.networkType.description }}
                </div>
              </b-card-text>
            </b-card-body>
            <b-card-footer class="text-center">
              <b-button
                class="mr-1"
                variant="outline-primary"
                size="sm"
                @click="showEditNetworkModal(network)"
              >
                Edit
              </b-button>

              <b-button
                variant="outline-danger"
                size="sm"
                @click="showDeleteNetworkModal(network)"
              >
                Delete
              </b-button>
            </b-card-footer>
          </b-card>
        </b-col>
      </b-row>
    </b-card>

    <!-- add network modal -->

    <b-modal
      ref="addNetworkModal"
      v-model="showAddNetworkModal"
      title="Add Network"
      ok-title="Add Network"
      no-close-on-esc
      size="xl"
      @ok="addNetwork"
    >
      <template #modal-header>
        <h3 class="modal-title">
          Add Network
        </h3>
      </template>

      <template>
        <b-form>
          <b-row class="mb-2">
            <b-col>
              <b-form-input
                v-model="search"
                type="search"
                placeholder="Search for a network"
                @input="filterNetworkTypes"
              />
            </b-col>
          </b-row>

          <b-row class="mb-2">
            <b-col>
              <div class="d-flex flex-wrap">
                <b-button
                  v-for="(category, index) in categories"
                  :key="index"
                  variant="outline-primary"
                  class="mr-2 mb-2"
                  :pressed="category.name === 'LoraWAN Networks'"
                  :disabled="category.name !== 'LoraWAN Networks'"
                >
                  {{ category.name }}
                  <b-badge
                    variant="primary"
                    class="ml-1"
                  >
                    {{ category.count }}
                  </b-badge>
                </b-button>
              </div>
            </b-col>
          </b-row>

          <b-row>
            <b-col
              v-for="networkType in filteredNetworkTypes"
              :key="networkType.id"
              cols="12"
              sm="6"
              md="4"
              lg="3"
              class="mb-4"
              style="cursor: pointer"
              @click="selectNetworkType(networkType)"
            >
              <b-card
                class="h-100 border"
                no-body
                :border-variant="
                  networkType === selectedNetworkType ? 'success' : ''
                "
              >
                <b-card-header
                  class="d-flex justify-content-between align-items-center"
                >
                  <div>
                    <h5 class="mb-0">
                      {{ networkType.name }}
                    </h5>
                    <small class="text-muted">{{
                      networkType.identifier
                    }}</small>
                  </div>
                  <b-img
                    v-if="networkType.logoLink"
                    alt="Image"
                    :src="networkType.logoLink"
                    height="64"
                    width="64"
                  />
                </b-card-header>
                <b-card-body>
                  <b-card-text>
                    <div>
                      {{ networkType.description }}
                    </div>
                  </b-card-text>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>

          <div
            v-if="
              selectedNetworkType &&
                selectedNetworkType.identifier !== 'virtual-network'
            "
          >
            <hr>
            <b-form-group
              :label="selectedNetworkType.identifier === 'prym-chirpstack' ? 'Tenant ID' : 'Org ID'"
              label-for="api-key"
            >
              <b-form-input
                id="orgId"
                v-model="orgId"
                type="text"
                required
                :placeholder="selectedNetworkType.identifier === 'prym-chirpstack' ? 'Enter Tenant ID' : 'Enter Org ID'"
              />

              <b-form-input
                id="api-key"
                v-model="apiKey"
                class="mt-2"
                type="text"
                required
                placeholder="Enter API Key"
              />
            </b-form-group>

            <b-button
              :variant="apiKey !== '' ? 'success' : 'secondary'"
              :disabled="!apiKey"
              class="mb-1 mt-1"
              @click="testNetwork"
            >Test Connection</b-button>
          </div>
        </b-form>
      </template>

      <template #modal-footer="{ hide }">
        <b-button
          variant="secondary"
          @click="hide"
        >
          Close
        </b-button>
        <b-button
          variant="primary"
          @click="addNetwork"
        >
          Add Network
        </b-button>
      </template>
    </b-modal>

    <!-- edit network modal

    <workspace-networks-edit :network="selectedNetwork" />
-->

    <!-- delete network modal -->

    <b-modal
      id="delete-Network-modal"
      ref="deleteNetworkModal"
      title="Delete Network"
      hide-footer
      hide-header-close
      no-close-on-esc
    >
      <p>Are you sure you want to delete this network?</p>
      <p v-if="deleteNetworkItem !== null">
        <b>
          {{ deleteNetworkItem.networkType.name }} -
          {{ deleteNetworkItem.networkOrgName }}
        </b>
      </p>
      <b-button
        variant="danger"
        class="mb-1 mt-1"
        @click="deleteNetwork"
      >
        Delete Network
      </b-button>
      <b-button
        variant="secondary"
        class="mb-1 mt-1"
        @click="closeDeleteNetworkModal"
      >
        Cancel
      </b-button>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BButton,
  BForm,
  BModal,
  BFormInput,
  BImg,
  BFormGroup,
  BCard,
  BCardBody,
  BCardHeader,
  BCardText,
  BCardFooter,
  BBadge,
} from 'bootstrap-vue'
// import vSelect from 'vue-select'
import { API } from 'aws-amplify'
import * as queries from '@/graphql/queries'
import * as mutations from '@/graphql/mutations'
// import WorkspaceNetworksEdit from './WorkspaceNetworksEdit.vue'

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BForm,
    BModal,
    BImg,
    // vSelect,
    BFormInput,
    BFormGroup,
    BCard,
    BCardBody,
    BCardHeader,
    BCardText,
    BCardFooter,
    BBadge,

    // WorkspaceNetworksEdit,
  },
  data() {
    return {
      search: '',
      selectedNetwork: null,
      showAddNetworkModal: false,
      networkTypes: [],
      selectedNetworkType: null,
      networks: [],
      networkTestResponse: [],
      networkTestResponseFields: [
        { key: 'name', label: 'Org Name' },
        { key: 'dc_balance', label: 'DC Balance' },
      ],
      networkFields: [
        { key: 'networkType.name', label: 'Name' },
        { key: 'networkOrgName', label: 'Network Organization' },
        { key: 'actions', label: 'Actions' },
      ],
      deleteNetworkItem: null,
      orgId: '',
      apiKey: '',
      selectedCategories: [],
      categories: [
        {
          name: 'LoraWAN Networks',
          count: 3,
        },
        {
          name: 'Cellular Networks',
          count: 0,
        },
        {
          name: 'NB-IoT',
          count: 0,
        },
        {
          name: 'Connetivity Partners',
          count: 0,
        },
      ],
    }
  },
  computed: {
    filteredNetworks() {
      if (!this.search) {
        return this.networks
      }
      return this.networks.filter(
        network => network.networkType.name
          .toLowerCase()
          .includes(this.search.toLowerCase())
          || network.networkOrgName
            .toLowerCase()
            .includes(this.search.toLowerCase())
          || network.networkType.description
            .toLowerCase()
            .includes(this.search.toLowerCase()),
      )
    },
    filteredNetworkTypes() {
      if (this.search === '') {
        return this.networkTypes
      }
      const searchLower = this.search.toLowerCase()
      return this.networkTypes.filter(
        networkType => networkType.name.toLowerCase().includes(searchLower)
          || networkType.category.toLowerCase().includes(searchLower),
      )
    },
  },
  created() {
    this.listNetworksTypes()
    this.listNetworks()
  },
  methods: {
    async listNetworksTypes() {
      API.graphql({
        query: queries.listNetworkTypes,
      }).then(networkTypes => {
        // console.log(networkTypes)
        this.networkTypes = networkTypes.data.listNetworkTypes.items
      })
    },
    async listNetworks() {
      this.networks = []
      // get workspace id from local storage
      const workspaceId = JSON.parse(localStorage.getItem('workspace')).id
      let workspaceInfo
      await API.graphql({
        query: queries.getWorkspace,
        variables: { id: workspaceId },
      }).then(workspace => {
        workspaceInfo = workspace.data.getWorkspace
      })

      workspaceInfo.networks.items.forEach(async network => {
        await API.graphql({
          query: queries.getNetworkType,
          variables: { id: network.networkTypeNetworksId },
        }).then(networkType => {
          this.networks.push({
            id: network.id,
            networkType: networkType.data.getNetworkType,
            networkOrgName: network.networkOrgName,
            api_key: network.api_key,
          })
        })
      })
    },
    showEditNetworkModal(data) {
      this.selectedNetwork = data
      // console.log(this.selectedNetwork)
      this.$bvModal.show('edit-Network-modal')
    },
    showDeleteNetworkModal(data) {
      this.deleteNetworkItem = data
      this.$bvModal.show('delete-Network-modal')
    },
    closeDeleteNetworkModal() {
      this.$bvModal.hide('delete-Network-modal')
    },
    async deleteNetwork() {
      const input = {
        id: this.deleteNetworkItem.id,
      }
      await API.graphql({
        query: mutations.deleteNetwork,
        variables: { input },
      }).then(() => {
        this.$bvModal.hide('delete-Network-modal')
        this.listNetworks()
      })
    },
    async testNetwork() {
      let query = {}

      query = {
        network: this.selectedNetworkType.identifier,
        orgId: this.orgId,
        apiKey: this.apiKey,
        endpoint: this.selectedNetworkType.apiEndpoint,
      }

      try {
        // eslint-disable-next-line no-unused-vars
        const getOrg = await API.get('NetworkAPI', '/org', {
          queryStringParameters: query,
        })
        if (getOrg.response) {
          alert('Connection Successful')
        }
      } catch (error) {
        alert(`Connection Failed: ${error}`)
      }
    },
    async addNetwork() {
      const workspace = JSON.parse(localStorage.getItem('workspace'))
      const roles = ['admin', 'editor', 'viewer']
      const cognitoGroups = []
      roles.forEach(role => {
        cognitoGroups.push(`${workspace.id}.${role}`)
      })

      let orgId = ''
      if (this.selectedNetworkType.identifier === 'prym-chirpstack') {
        orgId = this.orgId
      } else {
        orgId = workspace.id
      }

      const input = {
        workspaceGroups: cognitoGroups,
        networkTypeNetworksId: this.selectedNetworkType.id,
        workspaceNetworksId: workspace.id,
        orgId,
        api_key: this.apiKey,
        networkOrgName: workspace.name,
      }
      // eslint-disable-next-line no-unused-vars
      const newNetwork = await API.graphql({
        query: mutations.createNetwork,
        variables: { input },
      })
      this.showAddNetworkModal = false
      this.listNetworks()
    },
    async editNetwork() {
      const input = {
        id: this.selectedNetworkType.id,
        api_key: this.apiKey,
      }
      // eslint-disable-next-line no-unused-vars
      const newNetwork = await API.graphql({
        query: mutations.updateNetwork,
        variables: { input },
      })
      this.$bvModal.hide('edit-Network-modal')
      this.listNetworks()
    },
    filterNetworkTypes() {
      // Do nothing in this method.
      // It's just here so the filter will be reapplied each time the user types in the search input.
    },
    selectNetworkType(networkType) {
      this.selectedNetworkType = networkType
    },
    filterNetworks() {},
  },
}
</script>

<style></style>
